<form [formGroup]="versicherungsVarianteFormGroup" appPropagateSubmit>
  <div class="row justify-content-center varianten-hv-row" id="produktart-hv">
    <mat-button-toggle-group class="hv-daten-variante-button-group" formControlName="produktart" #group="matButtonToggleGroup">
      <mat-button-toggle [value]="produktarten.Haushalt" aria-label="Haushalt" #hhvariantbutton>
        <img src="{{hhvariantbutton.checked ? 'assets/img/hv/Haushalt_gruen.png': 'assets/img/hv/Haushalt_grau.png' }}" alt="Haushalt-Logo">
        <h1>Haushalt</h1>
      </mat-button-toggle>
      <mat-button-toggle [value]="produktarten.Eigenheim" aria-label="Eigenheim" #ehvariantbutton>
        <img src="{{ehvariantbutton.checked ? 'assets/img/hv/Eigenheim_gruen.png': 'assets/img/hv/Eigenheim_grau.png' }}" alt="Eigenheim-Logo">
        <h1>Eigenheim</h1>
      </mat-button-toggle>
      <mat-button-toggle [value]="produktarten.Buendel" aria-label="Eigenheim mit Haushalt" #hhehvariantbutton>
        <img src="{{hhehvariantbutton.checked ? 'assets/img/hv/Haushalt_Eigenheim_gruen.png': 'assets/img/hv/Haushalt_Eigenheim_grau.png' }}" alt="Haushalt_Eigenheim-Logo">
        <h1>Eigenheim mit Haushalt</h1>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div class="row justify-content-center varianten-hv-row" id="gebaeudeart-hv" *ngIf="hhvariantbutton.checked">
    <mat-button-toggle-group class="hv-daten-variante-button-group" formControlName="gebaeudeart" #group="matButtonToggleGroup">
      <mat-button-toggle [value]="gebaeudearten.Wohnung" aria-label="Wohnung" #hhvariantwohnung_button>
        <img src="{{hhvariantwohnung_button.checked ? 'assets/img/hv/Wohnung_gruen.png': 'assets/img/hv/Wohnung_grau.png' }}" alt="Eigenheim-Logo">
        <h1>Wohnung</h1>
      </mat-button-toggle>
      <mat-button-toggle [value]="gebaeudearten.Haus" aria-label="Haus" #hhvarianthaus_button>
        <img src="{{hhvarianthaus_button.checked ? 'assets/img/hv/Haus_gruen.png': 'assets/img/hv/Haus_grau.png' }}" alt="Haushalt-Logo">
        <h1>Haus</h1>
      </mat-button-toggle>
      <div class="smallprint-gray hv-daten-variante-smallprint">
        Tipp: Bei Miete in einem Ein- oder Zweifamilienhaus können Sie auch nach Wohnnutzfläche versichern. Wählen Sie
        dafür bitte „Wohnung“.
      </div>
    </mat-button-toggle-group>
  </div>
  <div class="smallprint-gray hv-daten-variante-smallprint pt-3">
    Sie haben ihren gewöhnlichen Wohnsitz im Ausland, möchten aber einen österreichischen Nebenwohnsitz versichern? Gerne können Sie den Rechner benutzen. Für einen Vertragsabschluss wenden Sie sich bitte direkt an die zuständige Landesdirektion.
  </div>
</form>
